import { call, put, takeLatest } from 'redux-saga/effects';
import * as actionType from './actionTypes';
import AuthService from '../../services/auth.service';
import { API_ENDPOINTS, SnackbarHandlerSchema, httpRequest } from '../../utils';
import { handleLoginSideEffectAction, publishErrorAction, redirectToHomePageBasisRoleAction } from '../../appContainer/actions';
import { executeResetPasswordAction, getRecoveryLinkAction, loginAction } from './actions';
import { DEV_DATA, SNACKBAR_VARIANTS } from '../../utils/constants';
import { push } from 'connected-react-router';

function* handleLogin(action) {
  const auth = new AuthService();
  yield put(loginAction.Reset());
  yield put(loginAction.Loading(true));

  const { email, password } = action.payload;
  let loginCallResponse = {};
  // TODO - Remove this Dev WA
  if (email === DEV_DATA.email) {
    loginCallResponse.success = true;
    loginCallResponse.context = DEV_DATA.context;
  } else {
    loginCallResponse = yield call(httpRequest.post, API_ENDPOINTS.LOGIN_API_URL, { email, password });
  }

  if (loginCallResponse.success) {
    const { token, user } = loginCallResponse.context;
    auth.setToken(token);
    yield put(handleLoginSideEffectAction.Trigger({ user, token }));
    yield put(redirectToHomePageBasisRoleAction.Trigger({user}));
  } else {
    yield put(loginAction.Failure(loginCallResponse.message));
  }

  yield put(loginAction.Loading(false));
  yield put(loginAction.Success());
}

function* handleGetRecoveryLinkClickSaga(action) {
  yield put(getRecoveryLinkAction.Loading(true))
  const userKey = action.payload;

  if (!userKey) {
    yield put(getRecoveryLinkAction.Loading(false))
    yield put(getRecoveryLinkAction.Failure("No user key entered"))
    return
  }

  const recoveryResponse = yield call(httpRequest.post, API_ENDPOINTS.SEND_RECOVERY_EMAIL, { key: action.payload });

  if (recoveryResponse.success) {
    const {email} = recoveryResponse.context
    yield put(getRecoveryLinkAction.Success(email))
  } else {
    yield put(getRecoveryLinkAction.Failure(recoveryResponse.message));
  }

  yield put(getRecoveryLinkAction.Loading(false))
}

function* handleExecuteResetPasswordSaga(action) {
  yield put(executeResetPasswordAction.Loading(true))
  const {password, token} = action.payload;

  if (!password || !token) {
    return
  }

  const recoveryResponse = yield call(httpRequest.post, API_ENDPOINTS.RESET_PASSWORD_FROM_TOKEN_URL, { token, newPassword: password });

  if (recoveryResponse.success) {
    yield put(executeResetPasswordAction.Success())
    const successSnackbarObj = new SnackbarHandlerSchema(200, 'Password Reset Successful', SNACKBAR_VARIANTS.SUCCESS);
    yield put(publishErrorAction.Trigger(successSnackbarObj));
    yield put(push("/auth/login"))
  } else {
    yield put(executeResetPasswordAction.Failure(recoveryResponse.message));
  }

  yield put(executeResetPasswordAction.Loading(false))
}


export default function* loginPageSaga() {
  yield takeLatest(actionType.LOGIN_ACTIONTYPE.REQUEST, handleLogin);
  yield takeLatest(actionType.GET_RECOVERY_LINK_ACTIONTYPE.REQUEST, handleGetRecoveryLinkClickSaga)
  yield takeLatest(actionType.EXECUTE_RESET_PASSWORD_ACTIONTYPE.REQUEST, handleExecuteResetPasswordSaga)

}
